import React from "react";

import { Paper } from "@mui/material";

const EmailTemplate = ({ template }) => {
  return (
    <Paper className="border-1  min-h-[70vh] w-[95%] rounded-sm border-slate-700 bg-slate-100  p-4 md:w-[70%] ">
      <p>{template}</p>
    </Paper>
  );
};

export default EmailTemplate;
